import { ReactNode, useEffect, useState } from "react";
import SHA256 from "crypto-js/sha256";
import encHex from "crypto-js/enc-hex";
import { useChainId } from "../../lib/chains";
import { getContractsByChainId } from "../../config/contracts";
import { useLocalStorageByChainId } from "../../lib/localStorage";
import { loadAbStorage } from "../../config/ab";

const LOCAL_STORAGE_CONTRACTS_HASH_KEY = "contractsHash";

export function ContractsValidationProvider({ children }: { children: ReactNode }) {
  const [ready, setReady] = useState(false);
  const { chainId } = useChainId();
  const [contractsHash, setContractsHash] = useLocalStorageByChainId(
    chainId,
    `${LOCAL_STORAGE_CONTRACTS_HASH_KEY}`,
    ""
  );
  useEffect(() => {
    const currentContracts = getContractsByChainId(chainId);
    const currentHash = getContractsHash(currentContracts);
    if (contractsHash !== currentHash) {
      localStorage.clear();
      setContractsHash(currentHash);
      loadAbStorage();
    }
    setReady(true);
  }, [chainId, contractsHash, setContractsHash]);

  if (!ready) return null;

  return <>{children}</>;
}

function getContractsHash(contracts: unknown): string {
  const json = JSON.stringify(contracts);
  return SHA256(json).toString(encHex);
}
